import { LOGOUT_USER, ENV_CHANGE } from "../types/authTypes";
import {
  CREATE_AFFILIATE,
  FETCH_AFFILIATES,
  FETCH_AFFILIATE_STATS,
  FETCH_AFFILIATE_PAYMENTS
} from "../types/affiliateTypes";

const INITIAL_STATE = {
  list: [],
  stats: {},
  payments: {}
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_AFFILIATE:
      return {
        ...state,
        list: [action.payload, ...state.list]
      };
    
    case FETCH_AFFILIATES:
      return {
        ...state,
        list: action.payload
      };
    
    case FETCH_AFFILIATE_STATS:
      return {
        ...state,
        stats: {
          ...state.stats,
          [action.payload.code]: action.payload.stats
        }
      };
    
    case FETCH_AFFILIATE_PAYMENTS:
      return {
        ...state,
        payments: {
          ...state.payments,
          [action.payload.code]: {
            data: action.payload.payments,
            pagination: action.payload.pagination
          }
        }
      };
    
    case ENV_CHANGE:
    case LOGOUT_USER:
      return INITIAL_STATE;
    
    default:
      return state;
  }
};
